import { View, Text, TextProps } from 'react-native';
import * as SVG from 'react-native-svg';
import React from 'react';

// Safe wrapper for text rendering
interface SafeTextProps extends TextProps {
  children: React.ReactNode;
}

const SafeText: React.FC<SafeTextProps> = ({ children, style, ...props }) => {
  if (!children) return null;

  return (
    <Text style={style} {...props}>
      {children} {/* ✅ render nodes directly */}
    </Text>
  );
};

export const rules = {
  "heading1": (node, children, parent, styles) => (
    <SafeText key={node.key} style={[styles.heading, styles.heading1, { marginVertical: 10, fontSize: 24, fontWeight: 'bold' }]}>
      {children}
    </SafeText>
  ),
  "heading2": (node, children, parent, styles) => (
    <SafeText 
      adjustsFontSizeToFit 
      numberOfLines={2} 
      key={node.key} 
      style={[styles.heading, { marginVertical: 10, marginBottom: 20, fontSize: 20, fontWeight: 'bold' }, styles.heading2]}
    >
      {children}
    </SafeText>
  ),
  "heading3": (node, children, parent, styles) => (
    <SafeText key={node.key} style={[styles.heading, styles.heading3, { fontSize: 18, fontWeight: '600' }]}>
      {children}
    </SafeText>
  ),
  "heading4": (node, children, parent, styles) => (
    <View style={{ flexDirection: 'row', marginTop: 10, alignItems: 'center' }}>
      <SVG.Svg width={30} height={30} style={{ marginRight: 10 }}>
        <SVG.Circle cx={15} cy={15} r={5} stroke={'rgba(90,192,234,0.8)'} strokeWidth={2} fill={'white'} />
      </SVG.Svg>
      <SafeText key={node.key} style={[styles.heading, { flex: 1, fontWeight: 'bold', fontSize: 16 }, styles.heading4]}>
        {children}
      </SafeText>
    </View>
  ),
  "heading5": (node, children, parent, styles) => (
    <SafeText key={node.key} style={[styles.heading, { marginLeft: 25, fontWeight: '600', fontSize: 14 }, styles.heading5]}>
      {children}
    </SafeText>
  ),
  "code_inline": (node, children, parent, styles) => (
    <SafeText key={node.key} style={[styles.code, { lineHeight: 24, backgroundColor: '#f5f5f5', paddingHorizontal: 4, borderRadius: 3 }]}>
      {children}
    </SafeText>
  ),
  "inline": (node, children, parent, styles) => (
    <SafeText key={node.key} style={[styles.inline, { lineHeight: 24 }]}>
      {children}
    </SafeText>
  ),
  "paragraph": (node, children, parent, styles) => (
    <SafeText key={node.key} style={[styles.paragraph, { lineHeight: 22, marginVertical: 6 }]}>
      {children}
    </SafeText>
  ),
  "list_item": (node, children, parent, styles) => (
    <View key={node.key} style={{ flexDirection: 'row', marginVertical: 3, alignItems: 'flex-start' }}>
      <Text style={{ marginRight: 8, marginTop: 10, fontWeight: 'bold', minWidth: 12, lineHeight: 22, color: 'rgb(90,192,234)', fontSize: 18 }}>•</Text>
      <View style={{ flex: 1 }}>
        <SafeText style={[styles.paragraph, { lineHeight: 22, marginVertical: 0 }]}>
          {children}
        </SafeText>
      </View>
    </View>
  ),
  "strong": (node, children, parent, styles) => (
    <Text
      key={node.key}
      style={{
        backgroundColor: '#8b5cf6',
        color: 'white',
        fontWeight: '700',
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 6,
        overflow: 'hidden',
      }}
    >
      {children}
    </Text>
  ),
};
